import PropTypes from 'prop-types'
import Paper from 'components/Paper'
import Icon from 'components/Icon'
import TextButton from 'components/TextButton'
import Stack from '@mui/material/Stack'

const DashedBoxButton = ({ icon, label, noHover, children, ...props }) => (
  <Paper
    dash
    variant="transparent"
    variantHover={noHover ? undefined : 'neutral_400'}
    round
    selectable
    {...props}
  >
    {!!children && children}
    {!children && (
      <Stack
        p={1.5}
        display="grid"
        gap={1}
        justifyItems="center"
        alignItems="center"
        alignContent="center"
        textAlign="center"
        height="100%"
      >
        <Icon icon={icon} />
        <TextButton 
          color="tertiary" 
        >
          {label}
        </TextButton>
      </Stack>
    )}
  </Paper>
)

DashedBoxButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.any,
  noHover: PropTypes.bool,
}

export default DashedBoxButton
